import { Component } from '@angular/core';
import { ContentBlockViewComponent } from '@tytapp/content/content-block-view-component';
import { OfferSetBlock } from './offer-set-block';
import { ContentModule } from '@tytapp/content';


@Component({
    selector: 'tyt-offer-set-block',
    standalone: true,
    imports: [
        ContentModule
    ],
    template: `
          <tyt-embedded-offer-set [offerSetID]="block.offerId"></tyt-embedded-offer-set>
    `
})
export class ViewComponent extends ContentBlockViewComponent<OfferSetBlock> {
}
